module.exports = __webpack_public_path__ + "img/Loading_r_5.d082a75c.png";